import { css } from 'lit';
export default css `
  :host {
    display: block;
    padding: 0 var(--wui-spacing-xl) var(--wui-spacing-xl);
  }
`;
//# sourceMappingURL=styles.js.map